'use strict';

export default {
  optionsWrapper: {
    delete: {
      errorRule:
        'Vous ne pouvez pas supprimer un champ qui est utilisé dans les règles. Veuillez changer vos règles avant de supprimer ce champ.',
      confirmation: 'Voulez-vous vraiment supprimer ce champ?',
    },
  },
  multiSteps: {
    cancel: 'Annuler',
    save: 'Sauvegarder',
    addStep: 'Ajouter une étape',
    editStep: 'Modifier une étape',
    stepName: "Nom de l'étape",
    deleteStep: 'Supprimer cette étape?',
    delete: 'Supprimer',
    deleteModalHeader: 'Attention!',
    deleteConfirmation: 'Voulez-vous vraiment supprimer cette étape?',
    deleteRule:
      'Vous ne pouvez pas supprimer une étape quand un ou plusieurs de ses champs associés sont utilisés dans des règles.',
  },
  multiSections: {
    cancel: 'Annuler',
    save: 'Sauvegarder',
    sectionMultiple: 'Section multiple',
    multiple: 'Multiple',
    addSection: 'Ajouter une section',
    editSection: 'Modifier une section',
    sectionName: 'Nom de la section',
    deleteSection: 'Supprimer cette section?',
    delete: 'Supprimer',
    deleteModalHeader: 'Attention!',
    deleteConfirmation: 'Voulez-vous vraiment supprimer cette section?',
    deleteRule:
      'Vous ne pouvez pas supprimer une section quand un ou plusieurs de ses champs associés sont utilisés dans des règles.',
    changeToMultiple:
      'Vous ne pouvez pas changer pour une section multiple quand un ou plusieurs de ses champs associés sont utilisés dans des règles.',
  },
};
